/** Branded fallback shown when an accommodation has no photo. */
export const ACCOMMODATION_PLACEHOLDER_IMAGE =
  "/images/accommodation-placeholder.png";

/** Higher-res export for the PDP desktop hero. */
export const ACCOMMODATION_PLACEHOLDER_IMAGE_DESKTOP =
  "/images/accommodation-placeholder-desktop.png";

